<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <div class="fl m-r-30" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加工具
        </router-link>
      </div>
      <div class="fl w-300">
        <el-input placeholder="请输入开发工具名称/地址" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="id"
      label="ID">
      </el-table-column>
      <el-table-column
      prop="name"
      label="工具名称">
      </el-table-column>
      <el-table-column
      label="地址">
      <template scope="scope">
          <div>
            <a :href="scope.row.url" target="_blank" style="color:#555">{{scope.row.url}}</a>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      prop="remark"
      label="备注">
      </el-table-column>
      <el-table-column
      label="状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==1" style="color:#0c0">正常</span>
            <span v-else-if = "scope.row.status ==0"  style="color:#bb0">{{ scope.row.status | status }}</span>
            <span v-else-if = "scope.row.status ==-1" style="color:#d00">{{ scope.row.status | status }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      label="操作"
      width="200">
        <template scope="scope">
          <div>
            <span>
              <el-button size="small" type="primary" @click="$router.push({ name: 'developmentEdit', params: { id: scope.row.id }})">编辑</el-button>
              <el-button size="small" type="danger" @click="confirmDelete(scope.row)">删除</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'development'"></btnGroup>
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        multipleSelection: [],
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除该工具?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _g.openGlobalLoading()
          this.apiDelete('admin/development/', item.id).then((res) => {
            _g.closeGlobalLoading()
            this.handelResponse(res, (data) => {
              _g.toastMsg('success', '删除成功')
              setTimeout(() => {
                _g.shallowRefresh(this.$route.name)
              }, 1500)
            })
          })
        }).catch(() => {
          // catch error
        })
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/development', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('development-save')
      },
      editShow() {
        return _g.getHasRule('development-update')
      },
      deleteShow() {
        return _g.getHasRule('development-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// list.vue?250259cc